module.exports = __webpack_public_path__ + "static/media/polygon.19fa0523.svg";